function Western() {
    return(
        <div>
        <h1>Western Category</h1>
        <img
      src={require("../../assets/images/pasta.jpg")}
      alt="pasta"
    /> <br/>
    <img
      src={require("../../assets/images/steak.jpg")}
      alt="steak"
    />
        </div>
    )

}
export default Western;